import { useQuery } from 'react-query';
import { AxiosError } from 'axios';

import { useApiContext } from 'context/ApiContext';
import { KEYS } from 'helpers/react-query.config';
import { useGlobalContext } from 'context/GlobalContext';

import { QueryValueProps } from '../usePagination';

interface QueryParams {
  ticketId: number;
  text?: string;
  orderColumn?: string;
  descending?: boolean;
  pageSize?: number;
  pageNumber?: number;
  NoInternal?: boolean;
}

export type Props = {
  filterParams?: QueryParams;
  queryProps?: QueryValueProps;
};

function useGetTicketComentsById({ filterParams, queryProps }: Props) {
  const { ticket: ticketApi } = useApiContext();
  const { showApiError, showApiAlert } = useGlobalContext();

  const { data: GetComments, isLoading: GetCommentsLoading } = useQuery(
    [KEYS.ticket.comment.list(), queryProps, filterParams],
    () =>
      ticketApi.comments.list({
        ...filterParams,
        ...queryProps
      }),
    {
      select: (data) => data?.data,
      refetchOnWindowFocus: false,
      onError: (error: AxiosError) =>
        error?.response?.request?.status === 500
          ? showApiError(error, error?.message)
          : showApiAlert(error, error?.response?.data?.detail)
    }
  );

  return {
    GetComments,
    GetCommentsLoading
  };
}

export default useGetTicketComentsById;
